import type { AnalyticsSink } from "./analyticsPorts.js";

/** Build/runtime platform tag used for analytics segmentation. */
export type AnalyticsPlatform = "web" | "native";

/** Transparent decorator that adds a platform parameter to every event. */
export class PlatformTaggingSink implements AnalyticsSink {
  constructor(
    private readonly inner: AnalyticsSink,
    private readonly platform: AnalyticsPlatform,
  ) {}

  log(event: string, params?: Record<string, string | number>): void {
    this.inner.log(event, { ...params, platform: this.platform });
  }
}
